/* External */
import cloneDeepL from "lodash/cloneDeep";
import { all, put, select, takeLatest, call } from "redux-saga/effects";

/* Services */
import { backendService } from "../../../services";

/* Others */
import { actionTypes, ACTION_TYPES_BASE_NAME, fetchPlayerContent, playerContentSuccess } from "./actions";
import { makeFetchSaga, PDP_ASSET_TYPES, STATUS_TYPES, TIME_ZONE, UNFINISHED_STATUS_TYPES } from "../../../utils";

function* getPlayerNextLiveContent() {
  const contentStatus = yield select((state) => state.player?.content?.status);

  if (UNFINISHED_STATUS_TYPES.includes(contentStatus)) return;

  const content = yield select((state) => state.player?.content?.data);

  if (content.length > 1) {
    const [, ...newContent] = content;

    return yield put(playerContentSuccess(newContent));
  }

  const assetId = yield select((state) => state.player?.station?.data?.id);

  yield put(fetchPlayerContent({ assetId, isLive: true }));
}

const fetchPlayerContentSaga = makeFetchSaga(
  ACTION_TYPES_BASE_NAME,
  {
    getFunc: ({ isLive }) => (isLive ? backendService.content.getSchedules : backendService.content.getEntity),
    getParams: ({ assetId, isLive }) =>
      isLive
        ? [
            {
              count: 2,
              fromDatetime: new Date(),
              region: TIME_ZONE,
              stationIDs: [assetId]
            }
          ]
        : [assetId]
  },
  (data, { isLive }) => (isLive ? data?.[0]?.schedules : data)
);

export function* getContent(payload) {
  const { assetId, assetType, isLive } = payload;
  const isSerie = PDP_ASSET_TYPES.series === assetType;

  if (isLive) {
    const findStation = (state) => {
      // try fetch from epg loaded data
      return state.epg.stationsWithSchedules?.data?.stations?.find(({ id }) => id === assetId);
    };

    const station = yield select(findStation);
    let schedules = {};

    if (!station) {
      // station schedule was not loaded in epg list, so ask just for
      const response = yield call(backendService.content.getSchedules, {
        count: 2,
        fromDatetime: new Date(),
        region: TIME_ZONE,
        stationIDs: [assetId]
      });

      schedules = response.data?.[0].schedules;
    }

    return cloneDeepL(station?.schedules || schedules);
  }

  const pdpStatus = yield select((state) => state.pdp.status);

  if (pdpStatus === STATUS_TYPES.UNLOAD_STATE) {
    const contentResponse = yield call(backendService.content.getEntity, assetId);

    return contentResponse.data;
  }

  if (isSerie) {
    const { assetId } = payload;
    const serieId = yield select((state) => state.pdp.asset.data?.id);
    const seasons = yield select((state) => state.pdp.seasons.data);

    for (let i = 0; i < seasons.length; i++) {
      const { episodes } = seasons[i];
      const episode = episodes.find((episode) => episode.id === assetId);

      if (episode) {
        return {
          ...episode,
          showID: serieId
        };
      }
    }
  }

  return yield select((state) => state.pdp.asset.data);
}

export function* getPlayerContent(payload) {
  const content = yield call(getContent, payload);

  return yield put(playerContentSuccess(content));
}

export default function* () {
  yield all([takeLatest(actionTypes.GET_PLAYER_NEXT_LIVE_CONTENT, getPlayerNextLiveContent), fetchPlayerContentSaga]);
}
